/**
 * JWT client-side decode utilities.
 * Only reads payload claims (no verification — that's the backend's job).
 */

/**
 * Decode JWT payload without verification.
 * We only need the `exp` claim to schedule proactive refresh.
 */
export function decodeJwtPayload(token: string): { exp: number; [key: string]: unknown } | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    // Base64url → Base64 → decode
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const json = atob(base64);
    return JSON.parse(json);
  } catch {
    return null;
  }
}

/**
 * Get seconds until token expires. Returns 0 if token is invalid or already expired.
 */
export function getTokenSecondsRemaining(token: string): number {
  const payload = decodeJwtPayload(token);
  if (!payload?.exp) return 0;
  const remaining = payload.exp - Math.floor(Date.now() / 1000);
  return Math.max(0, remaining);
}
